import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
// import ReactGA from 'react-ga'

import { SiteState } from '../store/site-reducer'
import Tag from './tag'
import Stars from '../assets/star-cluster-yellow.svg'
import { calendarBookingLink } from '../core/variables'

interface Props {
  type?: 'first-time'
  children: React.ReactElement
}

export function onClickTrack() {
  // ReactGA.event({
  //   category: 'Book a meeting',
  //   action: 'User click on book a meeting button',
  // })
}

export default function CampaignIntroContent({
  type,
  children,
}: Props): React.ReactElement {
  const { selected } = useSelector(({ site }: { site: SiteState }) => site)

  const { billingType } = selected || {}
  const isEnterpriseAccount = billingType === 'enterprise'

  if (!selected) {
    return <p />
  }

  if (isEnterpriseAccount) {
    return <>{children}</>
  }

  if (type === 'first-time') {
    return (
      <Tag inline icon={Stars}>
        <p>
          First time?{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={calendarBookingLink}
            onClick={onClickTrack}
          >
            Book a free setup consultation
          </a>{' '}
          or <Link to="/track/generator-help">view our setup guide</Link>.
        </p>
      </Tag>
    )
  }
  return (
    <Tag inline icon={Stars}>
      <p>
        Need more help?{' '}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={calendarBookingLink}
          onClick={onClickTrack}
        >
          Book a free setup consultation
        </a>
        .
      </p>
    </Tag>
  )
}
